// 设计稿
import React from 'react'
import ScrollImgs from '../../components/ScrollImgs'
import Title from '../../components/Title'

const DesignDiagram = ({ images = [] }) => {
  return (
    <>
      <Title title="设计稿" />
      <ScrollImgs imgs={images} />
    </>
  )
}

export default DesignDiagram
